import { type IControleDebitosGateway } from "../ports/ControleDebitosGateway";
import {
  ICriarTabelaDebitosUseCase,
  ITabelaDebitosDataSource
} from "../ports/CriarTabelaDebitos";
import { inject, injectable } from "inversify";
import { ContabilDITypes } from "@/services/contabil/types";
import "reflect-metadata";
import TabelaDebitosDataSourceDTO from "./TabelaDebitosDataSourceDTO";

@injectable()
export default class CriarTabelaDebitosUseCase
  implements ICriarTabelaDebitosUseCase
{
  @inject(ContabilDITypes.CONTROLE_DEBITOS_GATEWAY)
  private gateway!: IControleDebitosGateway;

  async criarTabela(): Promise<ITabelaDebitosDataSource[]> {
    try {
      const response = await this.gateway.get();

      return TabelaDebitosDataSourceDTO.execute(response.debitosEmpresa);
    } catch (e) {
      return [];
      // return TabelaDebitosDataSourceDTO.execute(controleDebitoFactory.build().debitosEmpresa)
    }
  }
}
